
document.querySelectorAll('.has-submenu').forEach(menuItem => {
    const submenu =
        menuItem.querySelector('.submenu') ||
        menuItem.querySelector('.right-submenu');

    if (!submenu) return;

    menuItem.addEventListener('mouseenter', () => {
        const menuTitle = menuItem.getAttribute('data-menu-title');

        // Show the submenu
        submenu.style.display = 'block';

        // Match the correct submenu list
        submenu.querySelectorAll('.submenu-list').forEach(subList => {
            const megaMenuTitle = subList.getAttribute('data-mega-menu');

            if (megaMenuTitle !== menuTitle) {
                subList.style.display = 'none';
            } else {
                subList.style.display = 'block';
            }
        });
    });

    menuItem.addEventListener('mouseleave', () => {
        submenu.style.display = 'none';
    });
});

// class CategorySlider extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     this.init();
//   }

//   init() {
//     const splideEl = this.querySelector('.splide');

//     if (!splideEl) return;

//     new Splide(splideEl, {
//       type: 'slide',
//       perPage: 11,
//       perMove: 1,
//       pagination: false,
//       arrows: true,
//       drag: true,
//       rewind: false,

//       breakpoints: {
//         1200: {
//           perPage: 8,
//         },
//         990: {
//           perPage: 6,
//         },
//         768: {
//           perPage: 4,
//         },
//         480: {
//           perPage: 3,
//         },
//       },
//     }).mount();
//   }
// }

// if (!customElements.get('category-slider')) {
//   customElements.define('category-slider', CategorySlider);
// }

// class AwardsSlider extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     const slider = this.querySelector('.splide');

//     if (!slider) return;

//     new Splide(slider, {
//       type: 'loop',
//       perPage: 4,
//       perMove: 1,
//       gap: '20px',
//       arrows: false,
//       pagination: false,
//       autoplay: true,
//       interval: 3000,
//       pauseOnHover: true,
//       breakpoints: {
//         990: {
//           perPage: 3,
//         },
//         749: {
//           perPage: 2,
//         },
//         480: {
//           perPage: 1,
//         },
//       },
//     }).mount();
//   }
// }

// customElements.define('awards-slider', AwardsSlider);

// class TestimonialSlider extends HTMLElement {
//   connectedCallback() {
//     const main = this.querySelector(".testimonial-main");
//     const nav = this.querySelector(".testimonial-nav");

//     if (!main || !nav) return;

//     const navSplide = new Splide(nav, {
//       type: "loop",
//       perPage: 5,
//       gap: "1rem",
//       rewind: false,
//       pagination: false,
//       arrows: true,
//       isNavigation: true,
//       focus: "center",
//       perPage: 5,
//       breakpoints: {
//         749: {
//           perPage: 5,
//         },
//       },
//     });

//     const mainSplide = new Splide(main, {
//       type: "loop",
//       perPage:1,
//       rewind: false,
//       pagination: false,
//       arrows: false,
//       drag: true,
//       autoHeight: true
//     });

//     mainSplide.sync(navSplide);

//     mainSplide.mount();
//     navSplide.mount();
    
//   }
// }

// customElements.define("testimonial-slider", TestimonialSlider);



document.querySelectorAll('.acc-headng-main').forEach((heading) => {
  heading.addEventListener('click', () => {
    heading.closest('.faqpage').classList.toggle('active');
  });
});




class TestimonialSlider extends HTMLElement {
  connectedCallback() {
    const main = this.querySelector(".testimonial-main");
    const nav = this.querySelector(".testimonial-nav");

    if (!main || !nav) return;

    const navSplide = new Splide(nav, {
      type: "loop",
      perPage: 5,
      gap: "1rem",
      rewind: false,
      pagination: false,
      arrows: true,
      isNavigation: true,
      focus: "center",
      breakpoints: {
        749: {
          perPage: 5,
        },
      },
    });

    const mainSplide = new Splide(main, {
      type: "loop",
      perPage: 1,
      rewind: false,
      pagination: false,
      arrows: false,
      drag: true
    });

    // Precision height engine targeting the inner content wrapper
    const adjustToContentHeight = () => {
      requestAnimationFrame(() => {
        const activeSlide = main.querySelector(".splide__slide.is-active");
        const track = main.querySelector(".splide__track");
        
        if (activeSlide && track) {
          const contentNode = activeSlide.querySelector(".testimonial-content");
          
          if (contentNode) {
            track.style.height = "auto";
            const contentHeight = contentNode.getBoundingClientRect().height;
            track.style.height = `${contentHeight}px`;
          }
        }
      });
    };

    mainSplide.sync(navSplide);

    mainSplide.mount();
    navSplide.mount();

    // Force absolute calculation instantly on first frame load
    adjustToContentHeight();

    // Listen for slide movements and dynamic content changes
    mainSplide.on("active move updated", adjustToContentHeight);

    const activeContent = main.querySelector(".splide__slide.is-active .testimonial-content");
    if (activeContent) {
      const resizeObserver = new ResizeObserver(() => {
        adjustToContentHeight();
      });
      resizeObserver.observe(activeContent);
    }

    window.addEventListener("resize", adjustToContentHeight);
  }
}

customElements.define("testimonial-slider", TestimonialSlider);